// EHU Mobility Plan - Translation System
// All UI strings in Spanish (es) and Basque (eu)

export type Locale = 'es' | 'eu';

export interface Translations {
  // ─── Header / Layout ──────────────────────────────────────
  title: string;
  subtitle: string;
  coverageButton: string;
  coverageTooltip: string;
  llegadas: string;
  salidas: string;
  llegadasTooltip: string;
  salidasTooltip: string;

  // ─── Loading / Errors ────────────────────────────────────
  loading: string;
  errorLoading: string;

  // ─── Persona Types ────────────────────────────────────────
  all: string;
  grado: string;
  master: string;
  tituloPropio: string;
  profesorado: string;
  ptgas: string;

  // ─── Transport Modes ──────────────────────────────────────
  bus: string;
  metro: string;
  tren: string;
  tranvia: string;

  // ─── KPI Cards ────────────────────────────────────────────
  demand: string;
  capacity: string;
  saturation: string;
  persons: string;
  seatsPerHour: string;
  noCoverage: string;

  // ─── Saturation Overview ──────────────────────────────────
  saturationByZone: string;
  lessThan60: string;
  between60and80: string;
  greaterThan80: string;
  noService: string;
  deficitThreshold: string;

  // ─── Zone / Campus Names ─────────────────────────────────
  territorioAlava: string;
  territorioGipuzkoa: string;
  territorioBizkaia: string;
  campusAlava: string;
  campusGipuzkoa: string;
  campusBizkaia: string;

  // ─── Time Slider ──────────────────────────────────────────
  timeFormat: string;
  volverInicio: string;
  anterior: string;
  pausar: string;
  reproducir: string;
  siguiente: string;
  tramoHorario: string;
  velocidad: string;

  // ─── Timeline Chart ──────────────────────────────────────
  capacidadVsDemanda: string;
  capacidadVsDemandaCampus: string;
  separarAreas: string;
  apilarAreas: string;
  apilado: string;
  separado: string;

  // ─── Sankey Diagram ──────────────────────────────────────
  flujosOrigen: string;
  flujosPorCampus: string;
  otros: string;
  personasTotal: string;
  personasEnEuskadi: string;

  // ─── Sidebar Toggle ───────────────────────────────────────
  toggleSidebar: string;

  // ─── Language Button ──────────────────────────────────────
  language: string;

  // ─── Nav menu (menú hamburguesa) ─────────────────────────
  navMenu: string;
  navDashboard: string;
  navCobertura: string;
  navEmisiones: string;

  // ─── Map controls ──────────────────────────────────────
  expanded: string;
  stacked: string;
  hidden: string;
  arrastra: string;
  cerrar: string;
  campusBtn: string;
  flowsBtn: string;
  flows: string;
  flow: string;
  control: string;
  flujos: string;
  min_pers: string;
  rutas_: string;
  paradas: string;
  selec_campus: string;
  rutas_llegan: string;
  click_ruta: string;
  ocultar_rutas: string;
  mostrar_rutas: string;
  limpiar_rutas: string;
  linea: string;
  para_ocultar_rutas: string;
  tp: string;
  pulsa: string;
  personas: string;
  quitarRuta: string;
  rutasAnimadas: string;
  mostrar: string;
  ocultar: string;
  facultad: string;

  // ─── GTFS Route Button ──────────────────────────────
  transporte: string;
  rutasHacia: string;
  paradasCampus: string;
  todasRutas: string;


  // ─── Map Tooltip ─────────────────────────────────────
  plazas: string;
  ruta: string;
  expediciones: string;
  campus_: string;
  clickDeseleccionar: string;
  clickAnimar: string;

  // ─── Zone Detail ─────────────────────────────────────
  personasViajando: string;
  sinCoberturaTP: string;
  noHayServicioTramo: string;
  demandaVsCapacidad: string;
  demandaEnTramo: string;
  capacidad_: string;
  sinServicioTramo: string;
  sinServicio: string;
  nivelSaturacion: string;
  sinServicio_: string;
  critico: string;
  alto: string;
  medio: string;
  bajo: string;
  sinDatosSaturacion: string;
  rutasTransporte: string;
  lineas: string;
  lineasMas: string;
  mostrarMenos: string;
  exp: string;

  // ─── Coverage Page ──────────────────────────────────────
  calculandoCobertura: string;
  errorCargandoDatos: string;
  volverDashboard: string;
  coberturaTPCampus: string;
  municipiosCoberturaInsuficiente: string;
  mostrarRutasGTFS: string;
  calcularRutasSecundarias: string;
  calculandoCount: string;
  calculadasCount: string;
  reintentar: string;
  soloDirectasON: string;
  soloDirectasOFF: string;
  soloProblematicos: string;
  soloDirectasTooltip: string;
  soloProblematicosTooltip: string;
  filtros: string;
  acciones: string;
  horaLlegada: string;
  todoElDia: string;
  mostrarOcultarMunicipios: string;
  mostrarOcultarCuellos: string;
  mostrarOcultarRutas: string;
  soloDirectasCorto: string;
  soloProblematicosCorto: string;
  pulsaCalcularRutas: string;
  obtenerRutasTransbordo: string;
  calculoBajoDemanda: string;
  errorCalculo: string;
  algunosMunicipiosOK: string;
  verDistribucionNivel: string;
  compactar: string;
  municipiosAnalizados: string;
  personasAfectadas: string;
  delTotal: string;
  coberturaAdecuada: string;
  personasBuenaCobertura: string;
  distribucionPorNivel: string;
  personas_: string;
  municipiosCount: string;
  ordenar: string;
  impacto: string;
  distancia: string;
  noMunicipiosFiltros: string;
  verTodos: string;
  rutasDirectas: string;
  rutasCasiDirecta: string;
  rutasDirExp: string;
  rutasCasiDirectas: string;
  rutasCasiDirExp: string;
  sinRutasDirectas: string;
  verMas: string;
  rutasNoDirectas: string;
  rutasDirectasCercanas: string;
  barrios: string;
  rutasDirectasNoAccesibles: string;
  mas_: string;
  clickAnimarRuta: string;
  rutasConTransbordo: string;
  opcionesOtp: string;
  walkOnlyCategory: string;
  transportCategorySingular: string;
  transportCategoryPlural: string;
  enColaCalculo: string;
  calculando: string;
  errorOTP: string;
  noRutasTransbordo: string;
  opcionNum: string;
  transbordo_: string;
  transbordos: string;
  quit: string;
  ocultarDesglose: string;
  verDesglose: string;
  total_: string;
  caminando: string;
  clickQuitarMapa: string;
  clickDibujarMapa: string;
  clickDetenerAnimacion: string;
  clickAnimarRutaMapa: string;
  detener: string;
  personasCoverage: string;
  personasOrden: string;
  refinadoPorOTP: string;
  modoSoloDirectas: string;
  nivelMostradoBase: string;
  sinContarTransbordo: string;
  calculandoRutasOTP: string;
  enColaOTP: string;
  errorNoDisponible: string;
  noPudieronCalcular: string;
  otpNoRutasTransbordo: string;
  coordenadasNoDisponibles: string;
  rutas: string;
  porCampusFallback: string;

  // ─── Coverage: niveles y descripciones ──────────────────
  nivelBuena: string;
  nivelAceptable: string;
  nivelInsuficiente: string;
  nivelNula: string;
  descBuena: string;
  descAceptable: string;
  descInsuficiente: string;
  descNula: string;
  dentroPueblo: string;

  // ─── Coverage: modos de transporte ──────────────────────
  modoBus: string;
  modoMetro: string;
  modoTren: string;
  modoTranvia: string;
  modoCaminando: string;
  modoBici: string;
  modoCoche: string;

  // ─── Coverage: mapa (tooltips, leyenda, controles) ──────
  clickDetenerAnimacionRuta: string;
  clickAnimarEstaRuta: string;
  tramoNumDeRutaTransbordo: string;
  origen: string;
  destino: string;
  transbordoPunto: string;
  tooltipPersonas: string;
  tooltipNivel: string;
  tooltipRutasDirectasAccesibles: string;
  tooltipExpediciones: string;
  tooltipRutasTransbordo: string;
  tooltipScore: string;
  tooltipTransbordoCorto: string;
  tooltipBoostCorto: string;
  vista: string;
  circulos: string;
  circulosTooltip: string;
  poligonos: string;
  poligonosTooltip: string;
  coberturaTPLegend: string;
  tamanoNumPersonas: string;
  colorNivelMunicipio: string;
  rutaAnimadaSingular: string;
  rutasAnimadasPlural: string;
  detenerTodasAnimaciones: string;
  rutaConTransbordo: string;
  leyendaOrigen: string;
  leyendaTransbordo: string;
  leyendaDestino: string;
  minutosCorto: string;
  transbCorto: string;
  metrosCorto: string;

  // ─── Coverage: sidebar (detalle municipio) ──────────────
  scoreLabel: string;
  transbCortoBonus: string;
  noDisponibleFallback: string;
  masCorredor: string;
  errorBadge: string;

  // ─── Coverage: ocupación / capacidad ────────────────────
  ocupacionLibre: string;
  ocupacionSaturado: string;
  ocupacionSinSubir: string;
  ocupacionNoCaben: string;
  ocupacionCompletaron: string;
  impactMunicipios: string;
  impactCuellos: string;
  bottleneckImpactLow: string;
  bottleneckImpactModerate: string;
  bottleneckImpactHigh: string;
  bottleneckImpactVeryHigh: string;
  bottleneckImpactShare: string;
  showMunicipalities: string;
  hideMunicipalities: string;
  showBottlenecks: string;
  hideBottlenecks: string;
  impactCompletados: string;
  impactEsperados: string;
  impactLlegaron: string;
  impactConRutaOtp: string;
  impactSinCompletar: string;
  impactDemandaTotal: string;
  impactExpediciones: string;
  impactExpedicionesSaturadas: string;
  impactBuscar: string;
  impactSoloProblemas: string;
  impactSinResultados: string;
  impactSinCalculo: string;
  impactCalculaOTP: string;
  impactMunicipiosConIncidencias: string;
  impactSinCobertura: string;
  impactPendiente: string;
  ocupacionTitulo: string;
  ocupacionTooltip: string;
  ocupacionSeLlenaEn: string;
  ocupacionLlenadoPor: string;
  ocupacionSubenAqui: string;
  ocupacionPlazasAntes: string;
  ocupacionYaEstabaLleno: string;
  ocupacionExpedicionesMunicipio: string;
  ocupacionSuben: string;
  ocupacionTotal: string;

  // ─── Coverage: inspector de expediciones (trip) ─────────
  tripInspectorTitulo: string;
  tripExpediciones: string;
  tripHorarios: string;
  tripSaturadas: string;
  tripMunicipios: string;
  tripMunicipiosEnMapa: string;
  tripParadas: string;
  tripPlazasLibres: string;
  tripOcupacionFinal: string;
  tripCronologia: string;
  tripCronologiaMixta: string;
  tripBuscarPlaceholder: string;
  tripSoloSaturadas: string;
  tripSinResultados: string;
  tripDestino: string;
  tripBajan: string;
  tripSuben: string;
  tripHoraPrevista: string;
  tripTransbordoDirecto: string;
  tripTransbordoAPie: string;
  tripCeroEmbarques: string;
  tripBloqueados: string;
  tripBloqueadosEnIntento: string;
  tripRutaPrincipal: string;
  tripRutaAlternativa: string;
  tripRutaNoUsada: string;
  tripOcupacionTrasBajada: string;
  tripOcupacionBus: string;
  tripSeQuedaronFuera: string;
  tripPlazasAgotadas: string;
  tripDemandaMunicipio: string;
  tripResultadosOrigen: string;
  tripLlegaronOrigen: string;
  tripAsignadosOrigen: string;
  tripSinAlternativaOrigen: string;
  tripSinResultadoOrigen: string;
  tripSeguirGrupo: string;
  tripLlegadaFinalGrupo: string;
  tripTransbordoGrupo: string;
  tripSubieronGrupo: string;

  
  // ─── Emissions: header / tabs ───────────────────────────
  emisionesCO2: string;
  analisisEmisionesRuta: string;
  emisiones: string;
  indiceCI: string;
  comparativa: string;

  // ─── Emissions: KPI cards ───────────────────────────────
  rutasEmissions: string;
  ahorroMedio: string;
  gco2PaxKm: string;

  // ─── Emissions: sidebar ─────────────────────────────────
  configuracion: string;
  emisionesSection: string;
  consumoBusDiesel: string;
  consumoCoche: string;
  emisionDiesel: string;
  emisionGasolina: string;
  ocupacionMediaBus: string;
  ocupacionMediaCoche: string;
  pesoPasajeroMedio: string;
  pesoBusVacio: string;
  capacidadMaxBus: string;
  coefPenalizacionCarga: string;
  regimenOperativo: string;
  consumoUrbanoDenso: string;
  consumoUrbanoFluido: string;
  consumoInterurbano: string;
  consumoAutopista: string;
  indiceComportamiento: string;
  configuracionTemporal: string;
  alphaStopDensity: string;
  fechaReferencia: string;
  fechaReferenciaHint: string;
  horaInicio: string;
  horaFin: string;
  calculandoEmissions: string;
  recalcularEmisiones: string;
  resetearValores: string;
  ejecutando: string;
  ejecutarScript: string;
  personasUnit: string;
  kgUnit: string;
  plazasUnit: string;
  l100km: string;

  // ─── Emissions: toasts ──────────────────────────────────
  calculoIniciadoTitle: string;
  calculoIniciadoDesc: string;
  calculoCompletadoTitle: string;
  calculoCompletadoDesc: string;
  errorTitle: string;
  errorRecalcular: string;
  errorConexionTitle: string;
  errorConexionDesc: string;
  timeoutCalculo: string;
  scriptEjecutadoTitle: string;
  scriptEjecutadoDesc: string;
  errorEjecutar: string;

  // ─── Emissions: mapa ────────────────────────────────────
  cargandoMapa: string;
  emisionesBus: string;
  emisionesCoche: string;
  co2BusTotal: string;
  co2CocheTotal: string;
  ahorroLabel: string;
  ahorroPorc: string;
  distanciaKm: string;
  velocidadKmh: string;
  regimenLabel: string;
  leyendaEmisiones: string;
  leyendaCI: string;
  leyendaComparativa: string;
  vistaEmisiones: string;
  vistaCI: string;
  vistaComparativa: string;
  filtrarRutas: string;
  rutasCount: string;
  deseleccionarTodas: string;
  seleccionarTodas: string;
  // Legend items
  leyBajo: string;
  leyMedio: string;
  leyAlto: string;
  leyMuyAlto: string;
  leyExcelente: string;
  leyBueno: string;
  leyRegular: string;
  leyBajoShort: string;
  // Rangos de leyenda (porcentajes) — en euskera el % va delante
  leyRangoExcelente: string;
  leyRangoBueno: string;
  leyRangoRegular: string;
  leyRangoBajo: string;
  // Tooltip prefixes
  ciPrefix: string;
  ahorroPrefix: string;
  emisionesPrefix: string;

  // ─── Emissions: demanda diaria (oferta vs demanda) ─────
  tabDemanda: string;
  demandaSubtitulo: string;
  bannerRatioPrefix: string;
  bannerRatioSuffix: string;
  bannerDistancia: string;
  kpiDemandaTotal: string;
  kpiPersonasDia: string;
  kpiUsuariosTp: string;
  kpiEmisionMedia: string;
  kpiAhorroPotencial: string;
  tpFull: string;
  coche: string;
  aPie: string;
  bici: string;
  chartDemandaNoTp: string;
  chartRepartoModal: string;
  chartEmisionPersona: string;
  chartEmisionTotal: string;
  personaDia: string;
  tablaPorZona: string;
  colZona: string;
  colDemanda: string;
  colPctTp: string;
  colOferta: string;
  colEmisTp: string;
  colRatio: string;
  sinOferta: string;
  ahorroFormulaLine: string;
  ahorroTtA: string;
  ahorroTtB: string;
  ahorroTtC: string;
  notaMetodologia: string;
  distanciaMedia: string;
  distanciaMediaHint: string;
  distanciaMediaHintZona: string;
  distanciaMediaGlobal: string;
  distFuentePanel: string;
  distFuenteCampus: string;
  distFuentePonderada: string;
  viajesDia: string;
  repartoNoTp: string;
  repartoNoTpHint: string;
  repartoTp: string;
  repartoTpHint: string;
  repartoTpModos: string;
  confRepartoModal: string;
  confViajesDistancias: string;
  confFactoresTitulo: string;
  unidadFactor: string;
  confSubPublico: string;
  confSubPrivado: string;
  factoresPaxKm: string;
  factorBus: string;
  factorCoche: string;
  factorMetro: string;
  factorTren: string;
  factorTranvia: string;
  ocupacionPrivHint: string;
  kmUnit: string;
  cargandoDemanda: string;
  apiNoDisponible: string;
  apiNoDisponibleDesc: string;

  // ─── Demanda diaria: análisis por zona ────
  selectorTitulo: string;
  selectorHint: string;
  zonaGlobal: string;
  zonaAnalizada: string;
  tablaHint: string;
  // ─── Demanda diaria: tooltips y notas de las barras ────
  ttDelTotal: string;
  ttFormulaLine: string;
  ttFactorTpNota: string;
  ttFactorNoTpNota: string;
  ttKmRutasNota: string;
  ttKmMediaNota: string;
  ttKmMixtaNota: string;
  ttKmNoTpNota: string;
  bannerKmRutas: string;
  notaKmRutas: string;
  notaKmMedia: string;
  notaKmMixta: string;
  metKmTp: string;
  ttComoSeCalcula: string;

  // ─── Demanda diaria: metodología (cómo se calcula) ────
  metIntro: string;
  met1Titulo: string;
  met1Formula: string;
  met1Texto: string;
  met2Titulo: string;
  met2Formula: string;
  met2Texto: string;
  met3Titulo: string;
  met3Formula: string;
  met3Texto: string;
  met4Titulo: string;
  met4Formula: string;
  met4Texto: string;
  met5Titulo: string;
  met5Formula: string;
  met5Texto: string;
  met6Titulo: string;
  met6Formula: string;
  met6Texto: string;
  met8Titulo: string;
  met8Formula: string;
  met8Texto: string;
  met9Titulo: string;
  met9Formula: string;
  met9Texto: string;

  // ─── Cobertura: anomalías + inspector (claves faltantes) ────
  anomalías: string;
  anomaliaOverflow: string;
  anomaliaSinCobertura: string;
  anomaliaCapacidad: string;
  anomaliaMuchosReintentos: string;
  ocupacionTiempoReal: string;
  ocupacionPorMunicipio: string;
  ocupacionFinal: string;
  cronologiaSubidas: string;
  tripInspector: string;
  buscarExpedicion: string;
  soloSaturadas: string;
  sinResultados: string;

  // ─── OTP Config Panel ────────────────────────────────────
  configuracionOTP: string;
  fecha: string;
  hora: string;
  arriveBy: string;
  llegada: string;
  salida: string;
  inicioViaje: string;
  seleccionarOrigen: string;
  horariosCompartidos: string;
  routePriorityScore: string;
  routePriorityDescription: string;
  showPriorityCriteria: string;
  hidePriorityCriteria: string;
  priorityWalkOnly: string;
  priorityTotalTime: string;
  priorityAccessWalk: string;
  priorityArrivalMargin: string;
  priorityTransfers: string;
  priorityAlternatives: string;
  priorityCapacity: string;
  fechaLabel: string;
  fechaDesc: string;
  horaLabel: string;
  horaDesc: string;
  arriveByLabel: string;
  arriveByDesc: string;
  allCampusesLabel: string;
  allCampusesDesc: string;
  routeDistributionLabel: string;
  moreConcentration: string;
  balancedDistribution: string;
  moreDistribution: string;
  walkOnlyShareLabel: string;
  passengersAssigned: string;
  otpNoRutasDisponibles: string;

}

export const translations: Record<Locale, Translations> = {
  es: {
    // Header
    title: 'MugiEHU',
    subtitle: 'Visor de Capacidad de Transporte Público',
    coverageButton: 'Cobertura TP',
    coverageTooltip: 'Analizar pueblos con cobertura insuficiente/nula por campus',
    llegadas: 'Llegadas',
    salidas: 'Salidas',
    llegadasTooltip: 'Ver vehículos y personas llegando al campus',
    salidasTooltip: 'Ver vehículos y personas saliendo del campus',

    // Loading
    loading: 'Cargando datos...',
    errorLoading: 'Error cargando datos:',

    // Personas
    all: 'Todos',
    grado: 'Grado',
    master: 'Máster',
    tituloPropio: 'Título propio',
    profesorado: 'Profesorado',
    ptgas: 'PTGAS',

    // Modes
    bus: 'Bus',
    metro: 'Metro',
    tren: 'Tren',
    tranvia: 'Tranvía',

    // KPIs
    demand: 'Demanda',
    capacity: 'Capacidad',
    saturation: 'Saturación',
    persons: 'personas',
    seatsPerHour: 'plazas/h',
    noCoverage: 'Sin cobertura',

    // Saturation
    saturationByZone: 'Saturación por Zona',
    lessThan60: '<60%',
    between60and80: '60-80%',
    greaterThan80: '>80%',
    noService: 'Sin servicio',
    deficitThreshold: 'Umbral déficit',

    // Campuses
    campusAlava: 'Campus de Álava',
    campusGipuzkoa: 'Campus de Gipuzkoa',
    campusBizkaia: 'Campus de Bizkaia',
    territorioAlava: 'Álava',
    territorioGipuzkoa: 'Gipuzkoa',
    territorioBizkaia: 'Bizkaia',

    // Time Slider
    timeFormat: '',
    volverInicio: 'Volver al inicio',
    anterior: 'Anterior',
    pausar: 'Pausar',
    reproducir: 'Reproducir',
    siguiente: 'Siguiente',
    tramoHorario: 'Tramo horario',
    velocidad: 'Velocidad',

    // Timeline Chart
    capacidadVsDemanda: 'Capacidad vs Demanda',
    capacidadVsDemandaCampus: 'Capacidad vs Demanda por campus',
    separarAreas: 'Separar áreas',
    apilarAreas: 'Apilar áreas',
    apilado: 'Apilado',
    separado: 'Separado',

    // Sankey Diagram
    flujosOrigen: 'Flujos de origen',
    flujosPorCampus: 'Flujos por campus',
    otros: 'Otros',
    personasTotal: 'personas en total',
    personasEnEuskadi: 'en Euskadi',

    // Sidebar
    toggleSidebar: 'Alternar panel lateral',

    // Language
    language: 'Idioma',

    // Nav menu
    navMenu: 'Menú',
    navDashboard: 'Inicio',
    navCobertura: 'Cobertura TP',
    navEmisiones: 'Emisiones',

    // Map Controls
    expanded: 'Barras separadas (click para apilar)',
    stacked: 'Barras apiladas (click para ocultar)',
    hidden: 'Barras ocultas (click para mostrar)',
    arrastra: 'Arrastra · Scroll · Click zona',
    cerrar: 'Cerrar',
    campusBtn: 'Campus',
    flowsBtn: 'Flujos de personas',
    flows: 'Flujos de personas',
    flow: 'Flujo de personas',
    control: 'Control de flujos',
    flujos: 'flujos',
    min_pers: 'Mínimo de personas',
    rutas_: 'rutas ·',
    paradas: 'paradas',
    selec_campus: 'Selecciona un campus para ver sus rutas',
    rutas_llegan: 'rutas llegan a',
    click_ruta: 'Click en una ruta para animarla',
    ocultar_rutas: 'Ocultar demás rutas',
    mostrar_rutas: 'Mostrar todas las rutas',
    limpiar_rutas: 'Limpiar todas',
    linea: 'Línea',
    para_ocultar_rutas: 'para ocultar demás rutas',
    tp: 'Transporte Público',
    pulsa: 'Pulsa',
    personas: 'personas',
    quitarRuta: 'Quitar ruta',
    rutasAnimadas: 'Rutas animadas',
    mostrar: 'Mostrar',
    ocultar: 'Ocultar',
    facultad: 'Facultad',

    // GTFS Route Button
    transporte: 'Transporte',
    rutasHacia: 'Rutas →',
    paradasCampus: 'Paradas campus',
    todasRutas: 'Todas las rutas',

    // Map Tooltip
    plazas: 'plazas',
    ruta: 'Ruta',
    expediciones: 'expediciones',
    campus_: 'Campus:',
    clickDeseleccionar: 'Click para deseleccionar',
    clickAnimar: 'Click para animar ruta',

    // Zone Detail
    personasViajando: 'personas viajando',
    sinCoberturaTP: 'Sin cobertura de transporte público',
    noHayServicioTramo: 'No hay servicio de transporte público en este tramo horario',
    demandaVsCapacidad: 'Demanda vs Capacidad',
    demandaEnTramo: 'demanda en este tramo',
    capacidad_: 'capacidad',
    sinServicioTramo: 'Sin servicio en este tramo',
    sinServicio: 'Sin servicio',
    nivelSaturacion: 'Nivel de saturación',
    sinServicio_: 'SIN SERVICIO',
    critico: 'CRÍTICO',
    alto: 'ALTO',
    medio: 'MEDIO',
    bajo: 'BAJO',
    sinDatosSaturacion: 'Sin datos de saturación',
    rutasTransporte: 'Rutas de transporte',
    lineas: 'líneas',
    lineasMas: 'líneas más',
    mostrarMenos: 'Mostrar menos',
    exp: 'exp',

    // Coverage Page
    calculandoCobertura: 'Calculando cobertura de transporte…',
    errorCargandoDatos: 'Error cargando datos:',
    volverDashboard: 'Volver al dashboard',
    coberturaTPCampus: 'Cobertura de Transporte Público · por campus',
    municipiosCoberturaInsuficiente: 'Municipios con cobertura insuficiente/nula por campus',
    mostrarRutasGTFS: 'Mostrar rutas GTFS como contexto',
    calcularRutasSecundarias: 'Calcular rutas secundarias',
    calculandoCount: 'Calculando {done}/{total}…',
    calculadasCount: 'Calculadas ({done}/{total})',
    reintentar: 'Reintentar',
    soloDirectasON: 'Solo directas: ON',
    soloDirectasOFF: 'Solo directas: OFF',
    soloProblematicos: 'Solo problemáticos',
    soloDirectasTooltip: 'Cuando está activado, los KPIs y los colores del mapa usan sólo el nivel base (rutas directas), ignorando las rutas secundarias calculadas. Útil para ver qué municipios quedarían mal cubiertos sin transbordos.',
    soloProblematicosTooltip: 'Filtrar para ver solo municipios con cobertura insuficiente o nula',
    filtros: 'Filtros',
    acciones: 'Acciones',
    horaLlegada: 'Hora de llegada',
    todoElDia: 'Todo el día',
    mostrarOcultarMunicipios: 'Mostrar/ocultar municipios',
    mostrarOcultarCuellos: 'Mostrar/ocultar cuellos de botella',
    mostrarOcultarRutas: 'Mostrar/ocultar rutas GTFS',
    soloDirectasCorto: 'Solo rutas directas',
    soloProblematicosCorto: 'Solo rutas problemáticas',
    pulsaCalcularRutas: 'Pulsa "Calcular rutas secundarias" para obtener rutas secundarias y refinar el nivel de detalle de cobertura de cada municipio.',
    obtenerRutasTransbordo: 'obtener rutas con transbordo (OTP) y refinar el nivel de cobertura de cada municipio. ',
    calculoBajoDemanda: 'El cálculo se hace bajo demanda, no se arranca automáticamente al cambiar de campus.',
    errorCalculo: 'Error en el cálculo: ',
    algunosMunicipiosOK: '. Algunos municipios pudieron calcularse correctamente.',
    verDistribucionNivel: 'Ver distribución por nivel',
    compactar: 'Compactar',
    municipiosAnalizados: 'Municipios analizados',
    personasAfectadas: 'Personas afectadas',
    delTotal: '% del total',
    coberturaAdecuada: 'Cobertura adecuada',
    personasBuenaCobertura: 'personas con buena cobertura',
    distribucionPorNivel: 'Distribución por nivel',
    personas_: 'pers.',
    municipiosCount: 'municipios',
    ordenar: 'Ordenar: ',
    impacto: 'Impacto',
    distancia: 'Distancia',
    noMunicipiosFiltros: 'No hay municipios con los filtros actuales.',
    verTodos: 'Ver todos',
    rutasDirectas: 'Rutas directas accesibles',
    rutasCasiDirecta: 'Sin transbordo',
    rutasDirExp: 'rutas dir. · ',
    rutasCasiDirectas: 'Rutas directas (trayecto a pie)',
    rutasCasiDirExp: 'rutas dir. (trayecto a pie) · ',
    sinRutasDirectas: 'sin rutas directas',
    verMas: 'Ver {n} más',
    rutasNoDirectas: 'Rutas no directas',
    rutasDirectasCercanas: 'Rutas directas cercanas',
    barrios: 'Barrios',
    rutasDirectasNoAccesibles: 'Rutas directas cercanas (no accesibles)',
    mas_: '+{n} más',
    clickAnimarRuta: 'Click en una ruta para animarla en el mapa.',
    rutasConTransbordo: 'Rutas con transbordo',
    opcionesOtp: 'Opciones de ruta OTP',
    walkOnlyCategory: 'Solo andando',
    transportCategorySingular: 'transporte',
    transportCategoryPlural: 'transportes',
    enColaCalculo: 'En cola para cálculo OTP…',
    calculando: 'Calculando…',
    errorOTP: 'error',
    noRutasTransbordo: 'OTP no encontró rutas con transbordo para este municipio.',
    opcionNum: 'Opción {n}',
    transbordo_: 'transbordo',
    transbordos: 'transbordos',
    quit: 'Quit',
    ocultarDesglose: 'Ocultar desglose',
    verDesglose: 'Ver desglose',
    total_: 'Total: ',
    caminando: 'caminando',
    clickQuitarMapa: 'Click para quitar del mapa',
    clickDibujarMapa: 'Click para dibujar en el mapa',
    clickDetenerAnimacion: 'Click para detener la animación',
    clickAnimarRutaMapa: 'Click para animar esta ruta en el mapa',
    detener: 'Detener',
    personasCoverage: 'personas',
    personasOrden: 'Cant. personas',
    refinadoPorOTP: 'Refinado por OTP: ',
    modoSoloDirectas: 'Modo "Solo rutas directas"',
    nivelMostradoBase: ': el nivel mostrado es el base, sin contar las rutas con transbordo (aunque estén calculadas abajo).',
    sinContarTransbordo: 'sin contar las rutas con transbordo (aunque estén calculadas abajo).',
    calculandoRutasOTP: 'Calculando rutas con transbordo (OTP)…',
    enColaOTP: 'En cola para cálculo OTP…',
    errorNoDisponible: 'Error: ',
    noPudieronCalcular: 'No se pudieron calcular rutas con transbordo (error de OTP o de red).',
    otpNoRutasTransbordo: 'OTP no encontró rutas con transbordo para este municipio.',
    coordenadasNoDisponibles: 'Coordenadas no disponibles',
    rutas: 'Rutas',
    porCampusFallback: 'por campus',

    // Coverage: niveles y descripciones
    nivelBuena: 'Buena',
    nivelAceptable: 'Aceptable',
    nivelInsuficiente: 'Insuficiente',
    nivelNula: 'Nula',
    descBuena: 'Rutas directas con capacidad suficiente para la demanda del municipio',
    descAceptable: 'Rutas directas con capacidad limitada pero que cubren parte de la demanda',
    descInsuficiente: 'Paradas cercanas al municipio pero sin rutas directas accesibles',
    descNula: 'Sin paradas de rutas directas a menos de 3 km del municipio',
    dentroPueblo: 'dentro',

    // Coverage: modos de transporte
    modoBus: 'Bus',
    modoMetro: 'Metro',
    modoTren: 'Tren',
    modoTranvia: 'Tranvía',
    modoCaminando: 'Caminando',
    modoBici: 'Bici',
    modoCoche: 'Coche',

    // Coverage: mapa (tooltips, leyenda, controles)
    clickDetenerAnimacionRuta: 'Click para detener la animación',
    clickAnimarEstaRuta: 'Click para animar esta ruta',
    tramoNumDeRutaTransbordo: 'Tramo {n} de la ruta con transbordo',
    origen: 'Origen',
    destino: 'Destino',
    transbordoPunto: 'Transbordo',
    tooltipPersonas: 'personas',
    tooltipNivel: 'Nivel:',
    tooltipRutasDirectasAccesibles: 'Rutas directas accesibles:',
    tooltipExpediciones: 'expediciones',
    tooltipRutasTransbordo: 'Rutas con transbordo:',
    tooltipScore: 'score',
    tooltipTransbordoCorto: 'transb.',
    tooltipBoostCorto: 'boost',
    vista: 'Vista',
    circulos: 'Círculos',
    circulosTooltip: 'Mostrar municipios como marcadores circulares',
    poligonos: 'Polígonos',
    poligonosTooltip: 'Rellenar el término municipal de cada pueblo con el color del nivel',
    coberturaTPLegend: 'Cobertura TP',
    tamanoNumPersonas: 'Tamaño = nº de personas',
    colorNivelMunicipio: 'Color = nivel del municipio',
    rutaAnimadaSingular: 'ruta animada',
    rutasAnimadasPlural: 'rutas animadas',
    detenerTodasAnimaciones: 'Detener todas las animaciones',
    rutaConTransbordo: 'Ruta con transbordo',
    leyendaOrigen: 'Origen',
    leyendaTransbordo: 'Transbordo',
    leyendaDestino: 'Destino',
    minutosCorto: 'min',
    transbCorto: 'transb.',
    metrosCorto: 'm',

    // Coverage: sidebar (detalle municipio)
    scoreLabel: 'score',
    transbCortoBonus: 'transb.',
    noDisponibleFallback: 'no disponible',
    masCorredor: 'más',
    errorBadge: 'error',

    // Coverage: ocupación / capacidad
    ocupacionLibre: 'libre',
    ocupacionSaturado: 'saturado',
    ocupacionSinSubir: 'no completaron el trayecto',
    ocupacionNoCaben: 'la simulación no registró su llegada al destino',
    ocupacionCompletaron: 'completaron el trayecto',
    impactMunicipios: 'Municipios',
    impactCuellos: 'Cuellos de botella',
    bottleneckImpactLow: 'Leve',
    bottleneckImpactModerate: 'Moderado',
    bottleneckImpactHigh: 'Grave',
    bottleneckImpactVeryHigh: 'Muy grave',
    bottleneckImpactShare: '{percent}% del total de {total} personas que no llegan',
    showMunicipalities: 'Mostrar municipios',
    hideMunicipalities: 'Ocultar municipios',
    showBottlenecks: 'Mostrar cuellos de botella',
    hideBottlenecks: 'Ocultar cuellos de botella',
    impactCompletados: 'Trayectos completados',
    impactEsperados: 'Personas esperadas',
    impactLlegaron: 'Llegaron al destino',
    impactConRutaOtp: 'con ruta OTP calculada',
    impactSinCompletar: 'Sin completar',
    impactDemandaTotal: 'de demanda calculada',
    impactExpediciones: 'expediciones',
    impactExpedicionesSaturadas: 'expediciones saturadas',
    impactBuscar: 'Buscar municipio…',
    impactSoloProblemas: 'Solo mostrar municipios con incidencias',
    impactSinResultados: 'No hay municipios con incidencias para este filtro.',
    impactSinCalculo: 'Aún no hay simulación de ocupación',
    impactCalculaOTP: 'Calcula las rutas secundarias para evaluar completados, bloqueos y saturación por municipio.',
    impactMunicipiosConIncidencias: 'municipios con incidencias',
    impactSinCobertura: 'personas sin itinerario OTP',
    impactPendiente: 'pendiente',
    ocupacionTitulo: 'Ocupación del transporte',
    ocupacionTooltip: 'Pasajeros a bordo / capacidad del vehículo. Si supera el 85% se considera saturado.',
    ocupacionSeLlenaEn: 'se llena en',
    ocupacionLlenadoPor: 'lleno por',
    ocupacionSubenAqui: 'suben aquí',
    ocupacionPlazasAntes: 'plazas antes',
    ocupacionYaEstabaLleno: 'ya venía lleno',
    ocupacionExpedicionesMunicipio: 'Expediciones de este municipio',
    ocupacionSuben: 'suben',
    ocupacionTotal: 'total',

    // Coverage: inspector de expediciones (trip)
    tripInspectorTitulo: 'Inspector de expediciones',
    tripExpediciones: 'expediciones',
    tripHorarios: 'horarios',
    tripSaturadas: 'saturadas',
    tripMunicipios: 'municipios',
    tripMunicipiosEnMapa: 'Municipios del trayecto',
    tripParadas: 'paradas',
    tripPlazasLibres: 'plazas libres',
    tripOcupacionFinal: 'Ocupación final',
    tripCronologia: 'Cronología de subidas',
    tripCronologiaMixta: 'Cronología de subidas y bajadas',
    tripDestino: 'Destino',
    tripBajan: 'Bajan',
    tripSuben: 'Suben',
    tripHoraPrevista: 'previsto',
    tripTransbordoDirecto: 'Transbordo directo · cambio de servicio',
    tripTransbordoAPie: 'Transbordo · cambio de servicio',
    tripCeroEmbarques: 'Esta opción no se eligió; la demanda fue a otra ruta',
    tripBloqueados: 'bloqueados',
    tripBloqueadosEnIntento: 'bloqueados en este intento',
    tripRutaPrincipal: 'Primera opción (salida más temprana)',
    tripRutaAlternativa: 'Alternativa intentada por falta de plazas',
    tripRutaNoUsada: 'No elegida en esta simulación',
    tripOcupacionTrasBajada: 'Ocupación tras bajada',
    tripOcupacionBus: 'Ocupación del bus',
    tripSeQuedaronFuera: 'personas se quedaron fuera',
    tripPlazasAgotadas: 'Se agotaron las plazas',
    tripDemandaMunicipio: 'Demanda por municipio',
    tripResultadosOrigen: 'Llegadas por municipio de origen',
    tripLlegaronOrigen: 'llegaron',
    tripAsignadosOrigen: 'asignados',
    tripSinAlternativaOrigen: 'sin alternativa',
    tripSinResultadoOrigen: 'sin resultado final',
    tripSeguirGrupo: 'Ver qué ocurrió con este grupo',
    tripLlegadaFinalGrupo: 'Llegaron al destino',
    tripTransbordoGrupo: 'Transbordo en',
    tripSubieronGrupo: 'subieron en',
    tripBuscarPlaceholder: 'Buscar expedición o municipio…',
    tripSoloSaturadas: 'Sólo saturadas',
    tripSinResultados: 'Sin expediciones que mostrar',

    
    // Emissions: header / tabs
    emisionesCO2: 'Emisiones CO₂',
    analisisEmisionesRuta: 'Análisis de emisiones por ruta',
    emisiones: 'Emisiones',
    indiceCI: 'Índice CI',
    comparativa: 'Comparativa',

    // Emissions: KPI cards
    rutasEmissions: 'Rutas',
    ahorroMedio: 'Ahorro Medio',
    gco2PaxKm: 'gCO₂/pax/km',

    // Emissions: sidebar
    configuracion: 'Configuración',
    emisionesSection: 'Emisiones',
    consumoBusDiesel: 'Consumo bus diésel (L/100km)',
    consumoCoche: 'Consumo coche (L/100km)',
    emisionDiesel: 'Emisión diésel (kg CO₂/L)',
    emisionGasolina: 'Emisión gasolina (kg CO₂/L)',
    ocupacionMediaBus: 'Ocupación media bus (personas)',
    ocupacionMediaCoche: 'Ocupación media coche (personas)',
    pesoPasajeroMedio: 'Peso pasajero medio (kg)',
    pesoBusVacio: 'Peso bus vacío (kg)',
    capacidadMaxBus: 'Capacidad máxima bus (plazas)',
    coefPenalizacionCarga: 'Coef. penalización carga',
    regimenOperativo: 'Régimen Operativo',
    consumoUrbanoDenso: 'Consumo urbano denso (L/100km)',
    consumoUrbanoFluido: 'Consumo urbano fluido (L/100km)',
    consumoInterurbano: 'Consumo interurbano (L/100km)',
    consumoAutopista: 'Consumo autopista (L/100km)',
    indiceComportamiento: 'Índice de Comportamiento',
    configuracionTemporal: 'Configuración Temporal',
    alphaStopDensity: 'Alpha stop density',
    fechaReferencia: 'Fecha de referencia (YYYY-MM-DD)',
    fechaReferenciaHint: 'Dejar vacío para usar fecha del feed GTFS',
    horaInicio: 'Hora inicio',
    horaFin: 'Hora fin',
    calculandoEmissions: 'Calculando...',
    recalcularEmisiones: 'Recalcular Emisiones',
    resetearValores: 'Resetear Valores',
    ejecutando: 'Ejecutando...',
    ejecutarScript: 'Ejecutar Script',
    personasUnit: 'personas',
    kgUnit: 'kg',
    plazasUnit: 'plazas',
    l100km: 'L/100km',

    // Emissions: toasts
    calculoIniciadoTitle: 'Cálculo iniciado',
    calculoIniciadoDesc: 'Recalculando emisiones con nuevos parámetros...',
    calculoCompletadoTitle: '✅ Cálculo completado',
    calculoCompletadoDesc: 'Los datos se han actualizado correctamente',
    errorTitle: 'Error',
    errorRecalcular: 'Error al recalcular',
    errorConexionTitle: 'Error de conexión',
    errorConexionDesc: 'No se pudo conectar con el servidor de emisiones',
    timeoutCalculo: 'Timeout: El cálculo tardó más de lo esperado',
    scriptEjecutadoTitle: 'Script ejecutado',
    scriptEjecutadoDesc: 'El dashboard se actualizará automáticamente',
    errorEjecutar: 'Error al ejecutar',

    // Emissions: mapa
    cargandoMapa: 'Cargando mapa...',
    emisionesBus: 'Emisiones bus:',
    emisionesCoche: 'Emisiones coche:',
    co2BusTotal: 'CO₂ bus (total):',
    co2CocheTotal: 'CO₂ coche (total):',
    ahorroLabel: '💡 Ahorro:',
    ahorroPorc: '% Ahorro:',
    distanciaKm: 'km',
    velocidadKmh: 'km/h',
    regimenLabel: 'Régimen',
    leyendaEmisiones: 'Emisiones (gCO₂/pax/km)',
    leyendaCI: 'Índice de Comportamiento',
    leyendaComparativa: 'Ahorro vs Coche',
    vistaEmisiones: '📊 Vista: Emisiones',
    vistaCI: '🏷️ Vista: Índice CI',
    vistaComparativa: '⚖️ Vista: Comparativa',
    filtrarRutas: '🗺️ Filtrar rutas',
    rutasCount: 'Rutas',
    deseleccionarTodas: 'Deseleccionar todas',
    seleccionarTodas: 'Seleccionar todas',
    // Legend items
    leyBajo: 'Bajo',
    leyMedio: 'Medio',
    leyAlto: 'Alto',
    leyMuyAlto: 'Muy Alto',
    leyExcelente: 'Excelente',
    leyBueno: 'Bueno',
    leyRegular: 'Regular',
    leyBajoShort: 'Bajo',
    leyRangoExcelente: '(>70%)',
    leyRangoBueno: '(50-70%)',
    leyRangoRegular: '(30-50%)',
    leyRangoBajo: '(<30%)',
    // Tooltip prefixes
    ciPrefix: 'CI:',
    ahorroPrefix: 'Ahorro:',
    emisionesPrefix: 'Emisiones:',

    // Demanda diaria (oferta vs demanda, emisiones por persona) - ESPAÑOL
    tabDemanda: 'Demanda diaria',
    demandaSubtitulo: 'Oferta y demanda diaria · emisiones por persona',
    bannerRatioPrefix: 'Cada persona que NO usa transporte público contamina',
    bannerRatioSuffix: 'veces más que una que sí lo usa',
    bannerDistancia: 'Viaje medio sin TP: {km} km · {viajes} viajes/día · {personas} personas/día',
    kpiDemandaTotal: 'Demanda diaria total',
    kpiPersonasDia: 'personas/día',
    kpiUsuariosTp: 'Usuarios de TP',
    kpiEmisionMedia: 'Emisión media por persona',
    kpiAhorroPotencial: 'Ahorro potencial del colectivo sin TP',
    tpFull: 'Transporte público',
    coche: 'Coche',
    aPie: 'A pie',
    bici: 'Bici',
    chartDemandaNoTp: 'No usan TP',
    chartRepartoModal: 'Reparto modal de la demanda diaria',
    chartEmisionPersona: 'Emisiones por persona y día (g CO₂)',
    chartEmisionTotal: 'Emisiones totales al día (kg CO₂)',
    personaDia: 'g CO₂/persona·día',
    tablaPorZona: 'Desglose por campus/zona',
    colZona: 'Zona',
    colDemanda: 'Demanda',
    colPctTp: '% TP',
    colOferta: 'Oferta/día',
    colEmisTp: 'TP g/p·día',
    colRatio: 'Ratio',
    sinOferta: 'Sin oferta',
    ahorroFormulaLine: 'Ahorro = {a} kg (hoy, sin TP) − {b} kg (el mismo colectivo en TP) = {c} kg CO₂/día',
    ahorroTtA: 'Emisión actual del colectivo que no usa TP: {n} personas × {pa} g/persona·día (coche; a pie y bici emiten 0)',
    ahorroTtB: 'El mismo colectivo viajando en TP: {n} personas × {pb} g/persona·día (media TP actual)',
    ahorroTtC: 'A − B: lo que se ahorraría si ese colectivo usara el TP',
    notaMetodologia: 'Metodología',
    metIntro: 'Todos los valores se calculan en el navegador con los parámetros del panel lateral. Así se obtiene cada uno:',
    met1Titulo: 'Factor por modo (g CO₂/pax·km)',
    met1Formula: 'bus, metro, tren y tranvía: factor directo · coche: L/100 km × kg CO₂/L × 10 ÷ ocupación',
    met1Texto: 'Los factores de bus, metro, tren y tranvía se fijan directamente en el panel (su ocupación ya está implícita en el factor). El coche se deriva de su consumo y su emisión por litro, repartidos entre la ocupación del vehículo. A pie y en bici el factor es 0.',
    met2Titulo: 'Factor TP ponderado',
    met2Formula: 'Σ (cuota del modo × factor del modo)',
    met2Texto: 'La cuota de cada modo la defines en el panel («Reparto de usuarios TP por modo»), con sliders acoplados que siempre suman 100%. En zonas donde un modo no presta servicio, su cuota se redistribuye entre los modos disponibles. El reparto de quien NO usa TP funciona igual (sliders acoplados a 100%).',
    met3Titulo: 'Emisión por persona y día',
    met3Formula: 'km/día × factor · km/día = km del viaje × viajes/día',
    met3Texto: 'Quien viaja en TP recorre los km medios de las rutas reales que sirven a su zona; quien no usa TP, la distancia media estimada para su campus. Cada colectivo aplica su factor ponderado.',
    met4Titulo: 'Ratio del banner',
    met4Formula: 'emisión sin TP ÷ emisión TP',
    met4Texto: 'Cuántas veces más contamina de media una persona que no usa TP frente a una que sí.',
    met5Titulo: 'Emisiones totales al día',
    met5Formula: 'personas del colectivo × su emisión por persona',
    met5Texto: 'La barra de TP usa los km de las rutas reales; la de «no usan TP» se desglosa en coche, a pie y bici según el reparto configurado y recorre la distancia media del campus. El número de personas que usan TP procede de la misma fuente que el dashboard de saturación.',
    met6Titulo: 'Ahorro potencial',
    met6Formula: 'personas sin TP × (emisión media sin TP − emisión media TP) ÷ 1000',
    met6Texto: 'Cuánto contaminaría el colectivo que hoy no usa TP si se pasara al TP: su emisión actual (coche; a pie y bici emiten 0) menos la del mismo número de personas viajando en TP. Es un límite teórico: asume que todo el colectivo cambia de modo (si la oferta lo permite).',
    met8Titulo: 'Distancia media por campus',
    met8Formula: 'Σ (km origen→campus × personas) ÷ personas · × 1,25 de desvío',
    met8Texto: 'Cada campus usa su propia distancia media, estimada con sus flujos reales de origen (línea recta × 1,25 de desvío viario). Si mueves el slider de distancia, fijas el mismo valor para todas las zonas; con el reset vuelves a las distancias por campus.',
    met9Titulo: 'Km del viaje en TP',
    met9Formula: 'km TP = Σ (cuota del modo × km medio del modo)',
    met9Texto: 'El km medio de cada modo sale de sus rutas reales en la zona, ponderadas por expediciones: Σ (expediciones × km de cada ruta) ÷ total de expediciones — las rutas con más servicios al día pesan más. Los modos se combinan con las cuotas del panel («Reparto de usuarios TP por modo»); si un modo no presta servicio en la zona, su cuota se redistribuye entre los disponibles.',
    distanciaMedia: 'Distancia media del viaje',
    distanciaMediaHint: 'Se estima por campus con los flujos reales origen→campus; si mueves el slider, fijas el mismo valor para todas',
    distanciaMediaHintZona: 'Estimada para esta zona con sus flujos reales; si mueves el slider, fijas el mismo valor para todas',
    distanciaMediaGlobal: 'media global estimada',
    distFuentePanel: 'fijada desde el panel (se aplica a todas las zonas)',
    distFuenteCampus: 'estimada para este campus con sus flujos reales',
    distFuentePonderada: 'media de los campus, ponderada por su demanda',
    viajesDia: 'Viajes por día (2 = ida y vuelta)',
    repartoNoTp: 'Reparto de quien NO usa TP',
    repartoNoTpHint: 'Sliders acoplados: siempre suman 100% (si subes uno, los demás bajan)',
    repartoTp: 'Reparto de usuarios TP por modo',
    repartoTpHint: 'Sliders acoplados: siempre suman 100% (si subes uno, los demás bajan). Solo se muestran los modos con servicio en la zona seleccionada.',
    repartoTpModos: '{n} modo(s) con servicio en esta zona',
    confRepartoModal: 'Reparto de viajeros',
    confViajesDistancias: 'Viajes y distancias',
    confFactoresTitulo: 'Factores de emisión',
    unidadFactor: 'g CO₂/pax·km',
    confSubPublico: 'Transporte público',
    confSubPrivado: 'Transporte privado',
    factoresPaxKm: 'Factores de emisión (g CO₂/pax·km)',
    factorBus: 'Factor bus',
    factorMetro: 'Factor metro',
    factorTren: 'Factor tren',
    factorTranvia: 'Factor tranvía',
    factorCoche: 'Factor coche',
    ocupacionPrivHint: 'La ocupación reparte la emisión del vehículo entre sus pasajeros: a más ocupación, menos g CO₂ por persona y km.',
    kmUnit: 'km',
    cargandoDemanda: 'Calculando demanda diaria...',
    apiNoDisponible: 'API de emisiones no disponible',
    apiNoDisponibleDesc: 'No se pudo conectar con el servicio Flask de emisiones (puerto 5001). Las vistas por ruta requieren este servicio.',

    // Demanda diaria: análisis por zona - ESPAÑOL
    selectorTitulo: 'Análisis por zona',
    selectorHint: 'Selecciona una zona para analizarla en detalle',
    zonaGlobal: 'Global (todos los campus)',
    zonaAnalizada: 'Zona analizada',
    tablaHint: 'Selecciona una zona para ver su análisis detallado',
    ttDelTotal: '{p}% del total',
    ttFormulaLine: '{pers} personas × {km} km/día × {f} g/pax·km',
    ttFactorTpNota: 'factor TP = Σ cuota de cada modo × su factor (cuotas del panel):',
    ttFactorNoTpNota: 'factor ponderado con el reparto sin TP del panel:',
    ttKmRutasNota: 'km: media de las longitudes reales de las rutas del área, ponderada por expediciones:',
    ttKmMediaNota: 'km: distancia media general (el área no tiene rutas con trazado conocido):',
    ttKmMixtaNota: 'km: mezcla de rutas reales y distancia media general (algunas zonas no tienen rutas con trazado):',
    ttKmNoTpNota: 'km: distancia media del campus, estimada con los flujos reales origen→campus:',
    bannerKmRutas: 'En TP el viaje medio sale de las rutas reales: {km} km de media',
    notaKmRutas: 'Km de TP: media real de las rutas que sirven a la selección, ponderada por expediciones (cuotas por modo ajustables en el panel).',
    notaKmMedia: 'Km de TP: distancia media general — la selección no tiene rutas con trazado conocido.',
    notaKmMixta: 'Km de TP: mezcla de rutas reales y distancia media (algunas zonas no tienen rutas con trazado).',
    metKmTp: 'km TP (rutas)',
    ttComoSeCalcula: 'Cómo sale cada barra:',

    // Cobertura: anomalías + inspector
    anomalías: 'Anomalías detectadas',
    anomaliaOverflow: 'Alto overflow: personas que no completaron el trayecto',
    anomaliaSinCobertura: 'Sin cobertura: personas sin servicio',
    anomaliaCapacidad: 'Expediciones saturadas',
    anomaliaMuchosReintentos: 'Baja tasa de subida',
    ocupacionTiempoReal: 'Ocupación en tiempo real',
    ocupacionPorMunicipio: 'Ocupación por municipio',
    ocupacionFinal: 'Ocupación final',
    cronologiaSubidas: 'Cronología de subidas',
    tripInspector: 'Inspector de expediciones',
    buscarExpedicion: 'Buscar…',
    soloSaturadas: 'Sólo saturadas',
    sinResultados: 'Sin expediciones',

    // OTP Config Panel - ESPAÑOL
    configuracionOTP: 'Configuración OTP',
    fecha: 'Fecha',
    hora: 'Hora',
    arriveBy: 'Llegada',
    llegada: 'Llegada',
    salida: 'Salida',
    inicioViaje: 'Inicio del viaje',
    seleccionarOrigen: 'Seleccionar origen',
    horariosCompartidos: 'Los horarios corresponden al transporte compartido; el acceso y la duración total varían según el origen.',
    routePriorityScore: 'Score de prioridad',
    routePriorityDescription: 'Puntuación basada en duración, acceso a pie, llegada, transbordos, alternativas y capacidad.',
    showPriorityCriteria: 'Ver puntuación por criterio',
    hidePriorityCriteria: 'Ocultar puntuación por criterio',
    priorityWalkOnly: 'Duración total andando',
    priorityTotalTime: 'Tiempo total del trayecto',
    priorityAccessWalk: 'Andando hasta la primera parada',
    priorityArrivalMargin: 'Margen de llegada antes de las 08:00',
    priorityTransfers: 'Número de transbordos',
    priorityAlternatives: 'Alternativas horarias posteriores',
    priorityCapacity: 'Capacidad nominal',
    fechaLabel: 'Fecha del viaje',
    fechaDesc: 'Día en el que se realiza el viaje',
    horaLabel: 'Hora del viaje',
    horaDesc: 'Hora de salida o llegada',
    arriveByLabel: 'Modo de búsqueda',
    arriveByDesc: 'Activado: buscar viajes que lleguen antes de la hora indicada. Desactivado: buscar viajes que salgan después de la hora indicada.',
    allCampusesLabel: 'Calcular para todos los campus',
    allCampusesDesc: 'Al calcular rutas secundarias, incluye todos los municipios de Álava, Gipuzkoa y Bizkaia.',
    routeDistributionLabel: 'Reparto de rutas',
    moreConcentration: 'Más concentración',
    balancedDistribution: 'Equilibrado',
    moreDistribution: 'Más reparto',
    walkOnlyShareLabel: 'Máximo de demanda andando',
    passengersAssigned: '{n} personas asignadas',
    otpNoRutasDisponibles: 'No hay rutas disponibles para este municipio.',

  },
  eu: {
    // Header - EUSKERA
    title: 'MugiEHU',
    subtitle: 'Garraio Publikoaren Ahalmena',
    coverageButton: 'GP Estaldura',
    coverageTooltip: 'Aztertu garraio publikoaren estaldura herrietan, campuseka',
    llegadas: 'Iritsierak',
    salidas: 'Irteerak',
    llegadasTooltip: 'Ikusi campusera iristen diren garraioak eta pertsonak',
    salidasTooltip: 'Ikusi campusetik irteten diren garraioak eta pertsonak',

    // Loading
    loading: 'Datuak kargatzen...',
    errorLoading: 'Errorea datuak kargatzen:',

    // Personas - EUSKERA
    all: 'Guztiak',
    grado: 'Gradu',
    master: 'Master',
    tituloPropio: 'Berezko titulu',
    profesorado: 'Irakaslegoa',
    ptgas: 'TEKAZEL',

    // Modes - EUSKERA
    bus: 'Autobusa',
    metro: 'Metroa',
    tren: 'Trena',
    tranvia: 'Tranbia',

    // KPIs - EUSKERA
    demand: 'Eskaria',
    capacity: 'Ahalmena',
    saturation: 'Asetasuna',
    persons: 'pertsona',
    seatsPerHour: 'eserleku/ordu',
    noCoverage: 'GP estaldurarik gabe',

    // Saturation - EUSKERA
    saturationByZone: 'Eremuaren araberako saturazioa',
    lessThan60: '<% 60',
    between60and80: '% 60-80',
    greaterThan80: '>% 80',
    noService: 'Zerbitzurik gabe',
    deficitThreshold: 'Defizitaren muga',

    // Campuses - EUSKERA
    campusAlava: 'Arabako Campusa',
    campusGipuzkoa: 'Gipuzkoako Campusa',
    campusBizkaia: 'Bizkaiko Campusa',
    territorioAlava: 'Araba',
    territorioGipuzkoa: 'Gipuzkoa',
    territorioBizkaia: 'Bizkaia',

    // Time Slider - EUSKERA
    timeFormat: '',
    volverInicio: 'Itzuli hasierara',
    anterior: 'Aurrekoa',
    pausar: 'Gelditu',
    reproducir: 'Erreproduzitu',
    siguiente: 'Hurrengoa',
    tramoHorario: 'Ordu tartea',
    velocidad: 'Abiadura',

    // Timeline Chart - EUSKERA
    capacidadVsDemanda: 'Ahalmena vs Eskaria',
    capacidadVsDemandaCampus: 'Ahalmena vs Eskaria campuseka',
    separarAreas: 'Bereiztu areak',
    apilarAreas: 'Pilatu areak',
    apilado: 'Pilatuta',
    separado: 'Bereiztuta',

    // Sankey Diagram - EUSKERA
    flujosOrigen: 'Jatorriko fluxuak',
    flujosPorCampus: 'Fluxuak campuseka',
    otros: 'Besteak',
    personasTotal: 'pertsona guztira',
    personasEnEuskadi: 'Euskadin',

    // Sidebar
    toggleSidebar: 'Alboko panela ezkutatu/erakutsi',

    // Language
    language: 'Hizkuntza',

    // Nav menu
    navMenu: 'Menua',
    navDashboard: 'Hasiera',
    navCobertura: 'GP Hedapena',
    navEmisiones: 'Isurketak',

    // Map Controls - EUSKERA
    expanded: 'Barra bereiztuak (klik egin pilatzeko)',
    stacked: 'Barra pilatuak (klik egin ezkutatzeko)',
    hidden: 'Barra ezkutuak (klik egin erakusteko)',
    arrastra: 'Arrastratu · Scroll · Egin klik eremuan',
    cerrar: 'Itxi',
    campusBtn: 'Campusa',
    flowsBtn: 'Pertsonen fluxuak',
    flows: 'Pertsonen fluxuak',
    flow: 'Pertsona fluxua',
    control: 'Fluxuen kontrola',
    flujos: 'fluxuak',
    min_pers: 'Pertsonen gutxienekoa',
    rutas_: 'ibilbideak ·',
    paradas: 'geltokiak',
    selec_campus: 'Hautatu campus bat bere ibilbideak ikusteko',
    rutas_llegan: 'hona heltzen diren ibilbideak: ',
    click_ruta: 'klik egin bide baten animatzeko',
    ocultar_rutas: 'Ezkutatu beste ibilbideak',
    mostrar_rutas: 'Erakutsi bide guztiak',
    limpiar_rutas: 'Garbitu dena',
    linea: 'Linea',
    para_ocultar_rutas: 'gainerako ibilbideak ezkutatzeko',
    tp: 'Garraio Publikoa',
    pulsa: 'Sakatu',
    personas: 'pertsona',
    quitarRuta: 'Kendu ibilbidea',
    rutasAnimadas: 'Ibilbide animatuak',
    mostrar: 'Erakutsi',
    ocultar: 'Ezkutatu',
    facultad: 'Fakultatea',

    // GTFS Route Button - EUSKERA
    transporte: 'Garraioa',
    rutasHacia: 'Ibilbideak →',
    paradasCampus: 'Campus geltokiak',
    todasRutas: 'Ibilbide guztiak',

    // Map Tooltip - EUSKERA
    plazas: 'eserlekuak',
    ruta: 'Ibilbidea',
    expediciones: 'espedizio',
    campus_: 'Campusa:',
    clickDeseleccionar: 'Egin klik desautatzeko',
    clickAnimar: 'Egin klik ibilbidea animatzeko',

    // Zone Detail - EUSKERA
    personasViajando: 'pertsona bidaiatzen',
    sinCoberturaTP: 'Garraio publikoaren estaldurarik gabe',
    noHayServicioTramo: 'Ez dago garraio publikoaren zerbitzurik tarte honetan',
    demandaVsCapacidad: 'Eskaria vs Ahalmena',
    demandaEnTramo: 'eskaria tarte honetan',
    capacidad_: 'ahalmena',
    sinServicioTramo: 'Zerbitzurik gabe tarte honetan',
    sinServicio: 'Zerbitzurik gabe',
    nivelSaturacion: 'Saturazio-maila',
    sinServicio_: 'ZERBITZURIK EZ',
    critico: 'KRITIKOA',
    alto: 'ALTUA',
    medio: 'ERTAINA',
    bajo: 'BAXUA',
    sinDatosSaturacion: 'Ez dago saturazio-daturik',
    rutasTransporte: 'Garraio-ibilbideak',
    lineas: 'linea',
    lineasMas: 'linea gehiago',
    mostrarMenos: 'Erakutsi gutxiago',
    exp: 'esp',

    // Coverage Page - EUSKERA
    calculandoCobertura: 'Garraioaren publikoaren estaldura kalkulatzen…',
    errorCargandoDatos: 'Errorea datuak kargatzen:',
    volverDashboard: 'Itzuli dashboard-era',
    coberturaTPCampus: 'Garraio publikoaren estaldura · campuseka',
    municipiosCoberturaInsuficiente: 'Estaldura urri/baliogabea duten herriak campuseka',
    mostrarRutasGTFS: 'Erakutsi GTFS ibilbideak testuinguru gisa',
    calcularRutasSecundarias: 'Kalkulatu bigarren mailako ibilbideak',
    calculandoCount: 'Kalkulatzen {done}/{total}…',
    calculadasCount: 'Kalkulatuta ({done}/{total})',
    reintentar: 'Saiatu berriro',
    soloDirectasON: 'Bide zuzenak: GAITU',
    soloDirectasOFF: 'Bide zuzenak: ITZALI',
    soloProblematicos: 'Problematikoak bakarrik',
    soloDirectasTooltip: 'Aktibatutakoan, KPIak eta maparen koloreak oinarrizko maila soilik erabiltzen dute (bide zuzenak), bigarren mailako ibilbideak baztertuz. Erabilgarria ikusteko zein udalerri geratuko liratekeen gaizki estalita transbordorik gabe.',
    soloProblematicosTooltip: 'Iragazi eskasa edo baliogabea den estaldura duten udalerriak bakarrik ikusteko',
    filtros: 'Iragazkiak',
    acciones: 'Ekintzak',
    horaLlegada: 'Irisera ordua',
    todoElDia: 'Egun osoa',
    mostrarOcultarMunicipios: 'Erakutsi/ezkutatu udalerriak',
    mostrarOcultarCuellos: 'Erakutsi/ezkutatu botila-lepoak',
    mostrarOcultarRutas: 'Erakutsi/ezkutatu GTFS ibilbideak',
    soloDirectasCorto: 'Bide zuzenak bakarrik',
    soloProblematicosCorto: 'Ibilbide problematikoak bakarrik',
    pulsaCalcularRutas: 'Sakatu "Kalkulatu bigarren mailako ibilbideak" bigarren mailako ibilbideak (OTP) lortzeko eta udalerri bakoitzaren estaldura gehiago zehazteko.',
    obtenerRutasTransbordo: ' lortzeko transbordoko ibilbideak (OTP) eta udalerri bakoitzaren estaldura ezagutzeko.',
    calculoBajoDemanda: 'Kalkulua eskatzen denean egiten da, ez da automatikoki abiarazten campus aldatzean.',
    errorCalculo: 'Errorea kalkuluan: ',
    algunosMunicipiosOK: '. Udalerri batzuk ondo kalkulatu ahal izan dira.',
    verDistribucionNivel: 'Ikusi xehetasunak mailaren arabera',
    compactar: 'Trinkotu',
    municipiosAnalizados: 'Aztertutako udalerriak',
    personasAfectadas: 'Eragindako pertsonak',
    delTotal: '% guztira',
    coberturaAdecuada: 'Hedapen egokia',
    personasBuenaCobertura: 'ondo konektatutako pertsona',
    distribucionPorNivel: 'Mailaren araberako banaketa',
    personas_: 'pert.',
    municipiosCount: 'udalerri',
    ordenar: 'Ordenatu: ',
    impacto: 'Eragina',
    distancia: 'Distantzia',
    noMunicipiosFiltros: 'Ez dago udalerririk hartutako iragazkiekin.',
    verTodos: 'Ikusi guztiak',
    rutasDirectas: 'Zuzeneko ibilbide erabilgarriak',
    rutasCasiDirecta: 'Transbordorik gabe',
    rutasDirExp: 'Zuzeneko ibil. · ',
    rutasCasiDirectas: 'Zuzeneko ibilbideak (tarte bat oinez)',
    rutasCasiDirExp: 'Zuzeneko ibil. (tarte bat oinez) · ',
    sinRutasDirectas: 'Zuzeneko ibilbiderik ez',
    verMas: 'Ikusi {n} gehiago',
    rutasNoDirectas: 'Ibilbide ez-zuzenak',
    rutasDirectasCercanas: 'Ibilbide zuzen hurbilenak',
    barrios: 'Auzoak',
    rutasDirectasNoAccesibles: 'Ibilbide zuzen hurbilenak (erabilgarriak ez)',
    mas_: '+{n} gehiago',
    clickAnimarRuta: 'Egin klik ibilbide bat animatzeko mapan.',
    rutasConTransbordo: 'Transbordodun ibilbideak',
    opcionesOtp: 'OTP ibilbide-aukerak',
    walkOnlyCategory: 'Oinez bakarrik',
    transportCategorySingular: 'garraio',
    transportCategoryPlural: 'garraio',
    enColaCalculo: 'Ilaran OTP kalkulurako…',
    calculando: 'Kalkulatzen…',
    errorOTP: 'errorea',
    noRutasTransbordo: 'OTPek ez du transbordodun ibilbiderik aurkitzen udalerri honetarako.',
    opcionNum: 'Aukera {n}',
    transbordo_: 'transbordo',
    transbordos: 'transbordo',
    quit: 'Utzi',
    ocultarDesglose: 'Ezkutatu xehetasunak',
    verDesglose: 'Ikusi xehetasunak',
    total_: 'Guztira: ',
    caminando: 'oinez',
    clickQuitarMapa: 'Egin klik mapatik kentzeko',
    clickDibujarMapa: 'Egin klik mapan marrazteko',
    clickDetenerAnimacion: 'Egin klik animazioa gelditzeko',
    clickAnimarRutaMapa: 'Egin klik bidea animatzeko mapan',
    detener: 'Gelditu',
    personasCoverage: 'pertsona',
    personasOrden: 'Pertsona kop.',
    refinadoPorOTP: 'OTP-ren arabera finduta: ',
    modoSoloDirectas: '"Bide zuzenak" modua',
    nivelMostradoBase: ': erakutsitako maila oinarrizkoa da, transbordoko bideak kontuan hartu gabe (behean kalkulatuak badira ere).',
    sinContarTransbordo: 'transbordoko bideak kontuan hartu gabe (behean kalkulatuak badira ere).',
    calculandoRutasOTP: 'Transbordoko bideak (OTP) kalkulatzen…',
    enColaOTP: 'Ilaran OTP kalkulurako…',
    errorNoDisponible: 'Errorea: ',
    noPudieronCalcular: 'Ezin izan dira transbordoko bideak kalkulatu (OTP edo sare errorea).',
    otpNoRutasTransbordo: 'OTP-ak ez du transbordoko biderik aurkitzen udalerri honetarako.',
    coordenadasNoDisponibles: 'Koordenatuak ez dira eskuragarriak',
    rutas: 'Bideak',
    porCampusFallback: 'campuseka',

    // Coverage: niveles y descripciones - EUSKERA
    nivelBuena: 'Ona',
    nivelAceptable: 'Onargarria',
    nivelInsuficiente: 'Eskasa',
    nivelNula: 'Nulua',
    descBuena: 'Udalerriaren eskariari erantzuteko ahalmen nahikoa duten ibilbide zuzenak',
    descAceptable: 'Ahalmen mugatua duten ibilbide zuzenak, baina eskariaren zati bat estaltzen dutenak',
    descInsuficiente: 'Udalerritik gertu dauden geltokiak, baina ibilbide zuzen erabilgarririk gabe',
    descNula: 'Ez dago ibilbide zuzenen geltokirik udalerritik 3 km-tik gutxiagora',
    dentroPueblo: 'herrigunean',

    // Coverage: modos de transporte - EUSKERA
    modoBus: 'Autobusa',
    modoMetro: 'Metroa',
    modoTren: 'Trena',
    modoTranvia: 'Tranbia',
    modoCaminando: 'Oinez',
    modoBici: 'Bizikleta',
    modoCoche: 'Autoa',

    // Coverage: mapa (tooltips, leyenda, controles) - EUSKERA
    clickDetenerAnimacionRuta: 'Egin klik animazioa gelditzeko',
    clickAnimarEstaRuta: 'Egin klik bide hau animatzeko',
    tramoNumDeRutaTransbordo: 'Transbordodun ibilbidearen {n}. zatia',
    origen: 'Jatorria',
    destino: 'Helmuga',
    transbordoPunto: 'Transbordo',
    tooltipPersonas: 'pertsona',
    tooltipNivel: 'Maila:',
    tooltipRutasDirectasAccesibles: 'Zuzeneko ibilbideak:',
    tooltipExpediciones: 'espedizio',
    tooltipRutasTransbordo: 'Transbordoa duten ibilbideak:',
    tooltipScore: 'score',
    tooltipTransbordoCorto: 'transb.',
    tooltipBoostCorto: 'boost',
    vista: 'Ikuspegia',
    circulos: 'Zirkuluak',
    circulosTooltip: 'Erakutsi udalerriak zirkulu-markatzaile gisa',
    poligonos: 'Poligonoak',
    poligonosTooltip: 'Bete udalerri bakoitzaren eremua mailaren kolorearekin',
    coberturaTPLegend: 'GP Estaldura',
    tamanoNumPersonas: 'Tamaina = pertsona kopurua',
    colorNivelMunicipio: 'Kolorea = udalerriaren maila',
    rutaAnimadaSingular: 'ibilbide animatu',
    rutasAnimadasPlural: 'ibilbide animatu',
    detenerTodasAnimaciones: 'Gelditu animazio guztiak',
    rutaConTransbordo: 'Transbordodun ibilbidea',
    leyendaOrigen: 'Jatorria',
    leyendaTransbordo: 'Transbordo',
    leyendaDestino: 'Helmuga',
    minutosCorto: 'min',
    transbCorto: 'transb.',
    metrosCorto: 'm',

    // Coverage: sidebar (detalle municipio) - EUSKERA
    scoreLabel: 'puntuazioa',
    transbCortoBonus: 'transb.',
    noDisponibleFallback: 'ez dago eskuragarri',
    masCorredor: 'gehiago',
    errorBadge: 'errorea',

    // Coverage: ocupación / capacidad - EUSKERA
    ocupacionLibre: 'libre',
    ocupacionSaturado: 'saturatuta',
    ocupacionSinSubir: 'ez dute ibilbidea osatu',
    ocupacionNoCaben: 'simulazioak ez du helmugara iritsi direla erregistratu',
    ocupacionCompletaron: 'ibilbidea osatu dute',
    impactMunicipios: 'Udalerriak',
    impactCuellos: 'Botila-lepoak',
    bottleneckImpactLow: 'Arina',
    bottleneckImpactModerate: 'Ertaina',
    bottleneckImpactHigh: 'Larria',
    bottleneckImpactVeryHigh: 'Oso larria',
    bottleneckImpactShare: 'Iristen ez diren {total} pertsonen %{percent}',
    showMunicipalities: 'Erakutsi udalerriak',
    hideMunicipalities: 'Ezkutatu udalerriak',
    showBottlenecks: 'Erakutsi botila-lepoak',
    hideBottlenecks: 'Ezkutatu botila-lepoak',
    impactCompletados: 'Osatutako bidaiak',
    impactEsperados: 'Espero ziren pertsonak',
    impactLlegaron: 'Helmugara iritsi dira',
    impactConRutaOtp: 'OTP ibilbidea kalkulatuta',
    impactSinCompletar: 'Osatu gabe',
    impactDemandaTotal: 'kalkulatutako eskariaren',
    impactExpediciones: 'espedizio',
    impactExpedicionesSaturadas: 'espedizio saturatu',
    impactBuscar: 'Bilatu udalerria…',
    impactSoloProblemas: 'Gorabeherak dituzten udalerriak bakarrik',
    impactSinResultados: 'Ez dago gorabeherarik iragazki honetan.',
    impactSinCalculo: 'Oraindik ez dago okupazio-simulaziorik',
    impactCalculaOTP: 'Kalkulatu bigarren mailako ibilbideak udalerriko osaketak, blokeoak eta saturazioa aztertzeko.',
    impactMunicipiosConIncidencias: 'gorabeherak dituzten udalerri',
    impactSinCobertura: 'OTP ibilbiderik gabeko pertsonak',
    impactPendiente: 'zain',
    ocupacionTitulo: 'Garraioaren okupazioa',
    ocupacionTooltip: 'Bidaiariak ontzian / ibilgailuaren ahalmena. % 85etik gora badago saturatutzat jotzen da.',
    ocupacionSeLlenaEn: 'hemen betetzen da',
    ocupacionLlenadoPor: 'honek beteta',
    ocupacionSubenAqui: 'hemen igotzen dira',
    ocupacionPlazasAntes: 'lehenagoko plaza',
    ocupacionYaEstabaLleno: 'jada beteta zetorren',
    ocupacionExpedicionesMunicipio: 'Udalerri honetako espedizioak',
    ocupacionSuben: 'igotzen dira',
    ocupacionTotal: 'guztira',

    // Coverage: inspector de expediciones (trip) - EUSKERA
    tripInspectorTitulo: 'Espedizioen ikuskatzailea',
    tripExpediciones: 'espedizio',
    tripHorarios: 'ordutegi',
    tripSaturadas: 'saturatuak',
    tripMunicipios: 'udalerri',
    tripMunicipiosEnMapa: 'Ibilbideko udalerriak',
    tripParadas: 'geldialdi',
    tripPlazasLibres: 'plaza libre',
    tripOcupacionFinal: 'Azken okupazioa',
    tripCronologia: 'Igotzeen kronologia',
    tripCronologiaMixta: 'Igotze eta jaitsieren kronologia',
    tripDestino: 'Helmuga',
    tripBajan: 'Jaisten',
    tripSuben: 'Igotzen',
    tripHoraPrevista: 'aurreikusita',
    tripTransbordoDirecto: 'Zuzeneko transbordoa · zerbitzu aldaketa',
    tripTransbordoAPie: 'Transbordoa · zerbitzu aldaketa',
    tripCeroEmbarques: 'Aukera hau ez da hautatu; eskaria beste ibilbide batera joan da',
    tripBloqueados: 'kanpoan geratu dira',
    tripBloqueadosEnIntento: 'saiakera honetan igo ezinik',
    tripRutaPrincipal: 'Lehen aukera (irteera goiztiarrena)',
    tripRutaAlternativa: 'Plaza faltagatik probatutako ordezkoa',
    tripRutaNoUsada: 'Simulazio honetan aukeratu gabe',
    tripOcupacionTrasBajada: 'Okupazioa jaitsi ondoren',
    tripOcupacionBus: 'Autobusaren okupazioa',
    tripSeQuedaronFuera: 'pertsona kanpoan geratu ziren',
    tripPlazasAgotadas: 'Plazak agortu ziren',
    tripDemandaMunicipio: 'Udaleko demanda',
    tripResultadosOrigen: 'Jatorrizko udalerriaren araberako helmugak',
    tripLlegaronOrigen: 'iritsi dira',
    tripAsignadosOrigen: 'esleituta',
    tripSinAlternativaOrigen: 'ordezkorik gabe',
    tripSinResultadoOrigen: 'azken emaitzarik gabe',
    tripSeguirGrupo: 'Ikusi talde honekin zer gertatu zen',
    tripLlegadaFinalGrupo: 'Helmugara iritsi dira',
    tripTransbordoGrupo: 'Transbordoa hemen',
    tripSubieronGrupo: 'hemen igo ziren',
    tripBuscarPlaceholder: 'Bilatu espedizioa edo udalerria…',
    tripSoloSaturadas: 'Saturatuak soilik',
    tripSinResultados: 'Erakusteko espediziorik ez',

    
    // Emissions: header / tabs - EUSKERA
    emisionesCO2: 'CO₂ isurketak',
    analisisEmisionesRuta: 'Ibilbidearen araberako isurketa-azterketa',
    emisiones: 'Isurketak',
    indiceCI: 'CI indizea',
    comparativa: 'Alderaketa',

    // Emissions: KPI cards - EUSKERA
    rutasEmissions: 'Bideak',
    ahorroMedio: 'Batez besteko aurrezpena',
    gco2PaxKm: 'gCO₂/pax/km',

    // Emissions: sidebar - EUSKERA
    configuracion: 'Konfigurazioa',
    emisionesSection: 'Isurketak',
    consumoBusDiesel: 'Diesel-autobusaren kontsumoa (L/100km)',
    consumoCoche: 'Autoaren kontsumoa (L/100km)',
    emisionDiesel: 'Diesel isurketa (kg CO₂/L)',
    emisionGasolina: 'Gasolina isurketa (kg CO₂/L)',
    ocupacionMediaBus: 'Autobusaren batezbesteko okupazioa (pertsona)',
    ocupacionMediaCoche: 'Autoaren batezbesteko okupazioa (pertsona)',
    pesoPasajeroMedio: 'Pertsonaren batezbesteko pisua (kg)',
    pesoBusVacio: 'Autobus hutsaren pisua (kg)',
    capacidadMaxBus: 'Autobusaren gehienezko ahalmena (plaza)',
    coefPenalizacionCarga: 'Kargaren penalizazio koef.',
    regimenOperativo: 'Eragiketa Erregimena',
    consumoUrbanoDenso: 'Hiri-kontsumo dentsoa (L/100km)',
    consumoUrbanoFluido: 'Hiri-kontsumo arina (L/100km)',
    consumoInterurbano: 'Interurbano kontsumoa (L/100km)',
    consumoAutopista: 'Autobide-kontsumoa (L/100km)',
    indiceComportamiento: 'Portaera Indizea',
    configuracionTemporal: 'Denbora Konfigurazioa',
    alphaStopDensity: '"Alpha stop" dentsitatea',
    fechaReferencia: 'Erreferentzia data (YYYY-MM-DD)',
    fechaReferenciaHint: 'Hutsik utzi GTFS feed-aren data erabiltzeko',
    horaInicio: 'Hasiera ordua',
    horaFin: 'Amaiera ordua',
    calculandoEmissions: 'Kalkulatzen...',
    recalcularEmisiones: 'Isurketak birkalkulatu',
    resetearValores: 'Balioak berriro ezarri',
    ejecutando: 'Exekutatzen...',
    ejecutarScript: 'Script-a exekutatu',
    personasUnit: 'pertsona',
    kgUnit: 'kg',
    plazasUnit: 'plaza',
    l100km: 'L/100km',

    // Emissions: toasts - EUSKERA
    calculoIniciadoTitle: 'Kalkulua hasi da',
    calculoIniciadoDesc: 'Isurketak birkalkulatzen parametro berriekin...',
    calculoCompletadoTitle: '✅ Kalkulua eginda',
    calculoCompletadoDesc: 'Datuak behar bezala eguneratu dira',
    errorTitle: 'Errorea',
    errorRecalcular: 'Errorea birkalkulatzean',
    errorConexionTitle: 'Konexio errorea',
    errorConexionDesc: 'Ezin izan da isurien zerbitzariarekin konektatu',
    timeoutCalculo: 'Timeout: Kalkulua espero zen baino gehiago luzatu da',
    scriptEjecutadoTitle: 'Scripta exekutatuta',
    scriptEjecutadoDesc: 'Dashboard-a automatikoki eguneratuko da',
    errorEjecutar: 'Errorea exekutatzean',

    // Emissions: mapa - EUSKERA
    cargandoMapa: 'Mapa kargatzen...',
    emisionesBus: 'Bus isurketak:',
    emisionesCoche: 'Auto isurketak:',
    co2BusTotal: 'CO₂ busa (guztira):',
    co2CocheTotal: 'CO₂ autoa (guztira):',
    ahorroLabel: '💡 Aurrezpena:',
    ahorroPorc: '% Aurrezpena:',
    distanciaKm: 'km',
    velocidadKmh: 'km/h',
    regimenLabel: 'Erregimena',
    leyendaEmisiones: 'Isurketak (gCO₂/pax/km)',
    leyendaCI: 'Portaera indizea',
    leyendaComparativa: 'Autoarekiko aurrezpena',
    vistaEmisiones: '📊 Ikuspegia: Isurketak',
    vistaCI: '🏷️ Ikuspegia: CI indizea',
    vistaComparativa: '⚖️ Ikuspegia: Alderaketa',
    filtrarRutas: '🗺️ Bideak iragazi',
    rutasCount: 'Bideak ',
    deseleccionarTodas: 'Desautatu guztiak',
    seleccionarTodas: 'Hautatu guztiak',
    // Legend items - EUSKERA
    leyBajo: 'Baxua',
    leyMedio: 'Ertaina',
    leyAlto: 'Altua',
    leyMuyAlto: 'Oso altua',
    leyExcelente: 'Bikaina',
    leyBueno: 'Ona',
    leyRegular: 'Nahikoa',
    leyBajoShort: 'Baxua',
    leyRangoExcelente: '(>% 70)',
    leyRangoBueno: '(% 50-70)',
    leyRangoRegular: '(% 30-50)',
    leyRangoBajo: '(<% 30)',
    // Tooltip prefixes - EUSKERA
    ciPrefix: 'CI:',
    ahorroPrefix: 'Aurrezpena:',
    emisionesPrefix: 'Isurketak:',

    // Demanda diaria (oferta vs demanda, emisiones por persona) - EUSKERA
    tabDemanda: 'Eguneko eskaria',
    demandaSubtitulo: 'Eguneko eskaintza eta eskaria · pertsonako isurketak',
    bannerRatioPrefix: 'Garraio publikoa erabiltzen ez duen pertsona bakoitzak',
    bannerRatioSuffix: 'aldiz gehiago kutsatzen du erabiltzen duen batek baino',
    bannerDistancia: 'GP gabe: {km} km batez besteko bidaia · eguneko {viajes} bidaia · eguneko {personas} pertsona',
    kpiDemandaTotal: 'Eguneko eskaria guztira',
    kpiPersonasDia: 'pertsona/egun',
    kpiUsuariosTp: 'GP erabiltzaileak',
    kpiEmisionMedia: 'Batez besteko isuria pertsonako',
    kpiAhorroPotencial: 'GP ez duen taldearen aurrezpen potentziala',
    tpFull: 'Garraio publikoa',
    coche: 'Autoa',
    aPie: 'Oinez',
    bici: 'Bizikleta',
    chartDemandaNoTp: 'GP erabiltzen ez dute',
    chartRepartoModal: 'Eguneko eskariaren banaketa modala',
    chartEmisionPersona: 'Isurketak pertsona eta eguneko (g CO₂)',
    chartEmisionTotal: 'Isurketak guztira eguneko (kg CO₂)',
    personaDia: 'g CO₂/pertsona·egun',
    tablaPorZona: 'Campuseko banaketa',
    colZona: 'Eremua',
    colDemanda: 'Eskaria',
    colPctTp: '% GP',
    colOferta: 'Eskaintza/egun',
    colEmisTp: 'GP g/p·egun',
    colRatio: 'Ratioa',
    sinOferta: 'Eskaintzarik gabe',
    ahorroFormulaLine: 'Aurrezpenak = {a} kg (GP gabe) − {b} kg (talde bera GPtan) = {c} kg CO₂/egun',
    ahorroTtA: 'GP erabiltzen ez duen taldearen gaurko isurketa: {n} pertsona × {pa} g/pertsona·egun (autoa; oinez eta bizikletan 0)',
    ahorroTtB: 'Talde bera GP-etan bidaiatuz: {n} pertsona × {pb} g/pertsona·egun (gaurko GP batezbestekoa)',
    ahorroTtC: 'A − B: Eguneko zenbat gutxiago isuriko litzatekeen, talde horrek GP erabiliko balu',
    notaMetodologia: 'Metodologia',
    metIntro: 'Balio guztiak nabigatzailean kalkulatzen dira alboko panelaren parametroekin. Honela lortzen da bakoitza:',
    met1Titulo: 'Moduko faktorea (g CO₂/pax·km)',
    met1Formula: 'autobusa, metroa, trena eta tranbia: faktore zuzena · autoa: L/100 km × kg CO₂/L × 10 ÷ okupazioa',
    met1Texto: 'Autobus, metro, tren eta tranbien faktoreak zuzenean finkatzen dira panelean (beren okupazioa faktorean dago jada). Autoarena bere kontsumo eta litroko isurpenetatik eratortzen da, ibilgailuaren okupazioaren artean banatuta. Oinez eta bizikletan faktorea 0 da.',
    met2Titulo: 'GP faktore haztatua',
    met2Formula: 'Σ (moduaren kuota × moduaren faktorea)',
    met2Texto: 'Modu bakoitzaren kuota panelean zehazten da («GP erabiltzaileen banaketa moduka»), beti % 100 egiten duten sliderrak erabiliz. Modu batek zerbitzurik ez duen eremuan, bere kuota modu erabilgarrien artean banatzen da. GP erabiltzen EZ duenen banaketak ere sistema bera du (sliderrak lotuta, % 100).',
    met3Titulo: 'Pertsonako isurketak eguneko',
    met3Formula: 'km/egun × faktorea · km/egun = bidaiaren km-ak × eguneko bidai',
    met3Texto: 'GP-n bidaiatzen duenak bere eremurako balio duten benetako ibilbideen batez besteko kilometroak egiten ditu; GP erabiltzen ez dutenentzako, bere campuserako zenbatetsitako batez besteko distantzia erabiltzen da. Kolektibo bakoitzak bere faktore haztatua aplikatzen du.',
    met4Titulo: 'Banner-eko ratioa',
    met4Formula: 'GP gabeko isurketa ÷ GP isurketa',
    met4Texto: 'Zenbat aldiz gehiago kutsatzen du batez beste GP erabiltzen ez duen pertsona batek GP-a erabiltzen duen batek baino.',
    met5Titulo: 'Eguneko isurketak guztira',
    met5Formula: 'taldeko pertsonak × pertsonako isurketa',
    met5Texto: 'GP barrak ibilbide errealen km-ak erabiltzen ditu; «GP erabiltzen ez dute» barrak autoaren, oinez eta bizikletaren artean banatzen da konfiguratutako banaketaren eta kanpuseko batez besteko distantzia arabera. GP erabiltzen duen pertsona kopurua asetasunaren dashboard-aren iturri beratik dator.',
    met6Titulo: 'Aurrezpen potentziala',
    met6Formula: 'GP gabeko pertsonak × (GP gabeko batezbesteko isurketa − GP erabiltzen dutenen batezbesteko isurketa) ÷ 1000',
    met6Texto: 'Gaur GP erabiltzen ez duen taldeak zenbat kutsatuko luke GP-ra pasatuko balitz: bere gaurko isurketa (autoa; oinez eta bizikletan 0) ken pertsona kopuru berak GPtan bidaiatuko lukeenarena. Muga teorikoa: talde osoa moduz aldatzeko GP eskaintzak baimentzen duela suposatzen da.',
    met8Titulo: 'Campusera batezbesteko distantzia',
    met8Formula: 'Σ (jatorri→Campus km × pertsonak) ÷ pertsonak · × 1,25 desbideratzea',
    met8Texto: 'Campus bakoitzak bere batezbesteko distantzia erabiltzen du, bere jatorrizko fluxu errealekin estimatua (lerro zuzena × 1,25). Distantzia-sliderra mugitzen baduzu, balio bera finkatzen duzu zona guztientzat; berrezarpenarekin kanpuseko distantzietara itzultzen zara.',
    met9Titulo: 'GP-etan bidaien km',
    met9Formula: 'GP km = Σ (moduaren kuota × moduaren batez besteko km-a)',
    met9Texto: 'Modu bakoitzaren batezbesteko km-ak bere ibilbide errealetatik ateratzen dira, espedizioen arabera ponderatuta: Σ (espedizioak × ibilbideko km) ÷ espedizio guztira — eguneko zerbitzu gehiago dituen ibilbideak gehiago pisatzen du. Moduak paneleko kuoteekin konbinatzen dira («GP erabiltzaileen banaketa moduka»); modu batek zerbitzurik ez badu eremuan, bere kuota erabilgarrien artean banatzen da.',
    distanciaMedia: 'Bidaiko batezbesteko distantzia',
    distanciaMediaHint: 'Campuseko estimatzen da jatorri→campus fluxu errealekin; slider-a mugitzen baduzu, balio bera finkatzen duzu eremu guztientzat',
    distanciaMediaHintZona: 'Eremu honentzat estimatuta bere fluxu errealekin; slider-a mugitzen baduzu, balio bera finkatzen duzu eremu guztientzat',
    distanciaMediaGlobal: 'batezbesteko globala',
    distFuentePanel: 'paneletik finkatua (eremu guztiei aplikatzen zaie)',
    distFuenteCampus: 'campus honentzat estimatuta bere fluxu errealekin',
    distFuentePonderada: 'campusen batezbestekoa, haien eskaeraren arabera ponderatua',
    viajesDia: 'Eguneko bidaia kopurua (2 = joan-etorria)',
    repartoNoTp: 'GP erabiltzen EZ dutenen banaketa',
    repartoNoTpHint: 'Slider-ak lotuta: beti batuta % 100 egiten dute (bat igotzen baduzu, gainerakoak jaisten dira)',
    repartoTp: 'GP erabiltzaileen banaketa moduka',
    repartoTpHint: 'Sliderr-ak lotuta: beti batuta % 100 egiten dute (bat igotzen baduzu, gainerakoak jaisten dira). Hautatutako eremuan zerbitzua duten moduak bakarrik erakusten dira.',
    repartoTpModos: 'Eremu honetan zerbitzua duten {n} modu',
    confRepartoModal: 'Bidaiarien banaketa',
    confViajesDistancias: 'Bidaiak eta distantziak',
    confFactoresTitulo: 'Isurpen faktoreak',
    unidadFactor: 'g CO₂/pax·km',
    confSubPublico: 'Garraio publikoa',
    confSubPrivado: 'Garraio pribatua',
    factoresPaxKm: 'Isurpen faktoreak (g CO₂/pax·km)',
    factorBus: 'Autobus faktorea',
    factorMetro: 'Metroaren faktorea',
    factorTren: 'Trenaren faktorea',
    factorTranvia: 'Tranbiaren faktorea',
    factorCoche: 'Auto faktorea',
    ocupacionPrivHint: 'Okupazioak ibilgailuaren isurpena bidaiarien artean banatzen du: okupazio gehiago, pertsona eta km bakoitzeko g CO₂ gutxiago.',
    kmUnit: 'km',
    cargandoDemanda: 'Eguneko eskaera kalkulatzen...',
    apiNoDisponible: 'Isurketa APIa ez dago erabilgarri',
    apiNoDisponibleDesc: 'Ezin izan da isurpen Flask zerbitzuarekin konektatu (5001 ataka). Bide horretako ikuspegiek zerbitzu hau behar dute.',

    // Demanda diaria: análisis por zona - EUSKERA
    selectorTitulo: 'Eremuko azterketa',
    selectorHint: 'Hautatu eremu bat xehetasunez aztertzeko',
    zonaGlobal: 'Globala (campus guztiak)',
    zonaAnalizada: 'Aztertutako eremua',
    tablaHint: 'Hautatu eremu bat bere azterketa xehea ikusteko',
    ttDelTotal: 'totalaren % {p}',
    ttFormulaLine: '{pers} pertsona × {km} km/egun × {f} g/pax·km',
    ttFactorTpNota: 'GP faktorea = Σ modu bakoitzaren kuota × bere faktorea (paneleko kuotak):',
    ttFactorNoTpNota: 'faktorea, paneleko GP gabeko banaketarekin haztatuta:',
    ttKmRutasNota: 'km: eremuari zerbitzu ematen dioten ibilbideen benetako luzeren batez bestekoa, espedizioen arabera haztatuta:',
    ttKmMediaNota: 'km: batezbesteko distantzia orokorra (eremuak ez du ibilbide ezagunik):',
    ttKmMixtaNota: 'km: ibilbide errealen eta batezbesteko distantzia orokorraren nahasketa (eremu batzuek ez dute ibilbide ezagunik):',
    ttKmNoTpNota: 'km: campuseko batezbesteko distantzia, jatorri→campus fluxu errealekin estimatuta:',
    bannerKmRutas: 'GP-en bidaia batezbestekoa benetako ibilbidetatik ateratzen da: batezbeste {km} km',
    notaKmRutas: 'GP km: hautapenari zerbitzu ematen dioten ibilbideen batezbestekoa, espedizioen arabera haztatuta (moduen kuotak panelean doitzen dira).',
    notaKmMedia: 'GP km: batezbesteko distantzia orokorra — hautapenak ez du ibilbide ezagunik.',
    notaKmMixta: 'GP km: ibilbide errealen eta batezbesteko distantziaren nahasketa (eremu batzuek ez dute ibilbide ezagunik).',
    metKmTp: 'GP km (ibilbideak)',
    ttComoSeCalcula: 'Nola sortzen den barra bakoitza:',

    // Cobertura: anomalías + inspector
    anomalías: 'Aurkitutako anomaliak',
    anomaliaOverflow: 'Gehiegizko overflow: ibilbidea ez duten amaitu pertsonak',
    anomaliaSinCobertura: 'Estaldu barik: zerbitzurik ez duten pertsonak',
    anomaliaCapacidad: 'Betetetako espedizioak',
    anomaliaMuchosReintentos: 'Igoera-tasa baxua',
    ocupacionTiempoReal: 'Denbora errealeko okupazioa',
    ocupacionPorMunicipio: 'Udalerriko okupazioa',
    ocupacionFinal: 'Azken okupazioa',
    cronologiaSubidas: 'Igoeren kronologia',
    tripInspector: 'Espedizioen ikuskatzailea',
    buscarExpedicion: 'Bilatu…',
    soloSaturadas: 'Beteta bakarrik',
    sinResultados: 'Espediziorik ez',

    // OTP Config Panel - EUSKERA
    configuracionOTP: 'OTP Konfigurazioa',
    fecha: 'Data',
    hora: 'Ordua',
    arriveBy: 'Iriste ordua',
    llegada: 'Iritsi',
    salida: 'Irten',
    inicioViaje: 'Bidaiaren hasiera',
    seleccionarOrigen: 'Aukeratu jatorria',
    horariosCompartidos: 'Ordutegiak partekatutako garraioari dagozkio; sarbidea eta iraupen osoa jatorriaren arabera aldatzen dira.',
    routePriorityScore: 'Lehentasun-puntuazioa',
    routePriorityDescription: 'Iraupenean, oinezko sarbidean, iristeko marjinean, transbordoetan, alternatibetan eta edukieran oinarritutako puntuazioa.',
    showPriorityCriteria: 'Ikusi irizpide bakoitzaren puntuazioa',
    hidePriorityCriteria: 'Ezkutatu irizpide bakoitzaren puntuazioa',
    priorityWalkOnly: 'Oinezko ibilbidearen iraupena',
    priorityTotalTime: 'Ibilbidearen guztizko denbora',
    priorityAccessWalk: 'Lehen geltokirainoko oinezko tartea',
    priorityArrivalMargin: '08:00ak baino lehen iristeko marjina',
    priorityTransfers: 'Transbordo kopurua',
    priorityAlternatives: 'Ondorengo ordutegi-alternatibak',
    priorityCapacity: 'Ibilgailuaren edukiera nominala',
    fechaLabel: 'Data',
    fechaDesc: 'Bidaiaren eguna',
    horaLabel: 'Ordua',
    horaDesc: 'Irteera edo iritsiera ordua',
    arriveByLabel: 'Iriste ordua',
    arriveByDesc: 'Aktibatuta, iristeko ordua da; desaktibatuta, irteerako ordua',
    allCampusesLabel: 'Campus guztietarako kalkulatu',
    allCampusesDesc: 'Bigarren mailako ibilbideak kalkulatzean, Araba, Gipuzkoa eta Bizkaiko udalerri guztiak sartzen ditu.',
    routeDistributionLabel: 'Ibilbideen banaketa',
    moreConcentration: 'Kontzentrazio handiagoa',
    balancedDistribution: 'Orekatua',
    moreDistribution: 'Banaketa handiagoa',
    walkOnlyShareLabel: 'Oinezko eskariaren gehienekoa',
    passengersAssigned: '{n} pertsona esleituta',
    otpNoRutasDisponibles: 'Ez dago udalerri honetarako ibilbide erabilgarririk.',

  },
};

export function getTranslations(locale: Locale): Translations {
  return translations[locale];
}

export default translations;